
export const LabelWithValue = (props: any) => {
  const { label, value } = props;
  return (
    <div className="label-value-item d-flex py-2 ps-0">
      {
        label && <div className="label mr-2">
          {label}
        </div>
      }

      <div className="value">
        {value}
      </div>
    </div>
  )
}
